import React, { StrictMode } from 'react';
// import ReactDOM from 'react-dom';
import ReactDOM from "react-dom/client"
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store';
import Firebase, { FirebaseContext } from './services/firebase';
// import { MemoryRouter } from 'react-router-dom';
import './index.css';
import App from './containers/App';
import Spinner from './components/Spinner';
import ErrorBoundary from './components/ErrorBoundary';
import { createTheme, ThemeProvider, THEME_ID as MATERIAL_THEME_ID } from '@mui/material/styles';
import { CssVarsProvider as JoyCssVarsProvider } from '@mui/joy/styles';

// Make MUI components use the same type system as the rest of the site:
// Inter for body/UI, Plus Jakarta Sans for headings.
const DISPLAY_FONT = '"Plus Jakarta Sans", Inter, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif';
const BODY_FONT = 'Inter, system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';
const muiTheme = createTheme({
  typography: {
    fontFamily: BODY_FONT,
    h1: { fontFamily: DISPLAY_FONT },
    h2: { fontFamily: DISPLAY_FONT },
    h3: { fontFamily: DISPLAY_FONT },
    h4: { fontFamily: DISPLAY_FONT },
    h5: { fontFamily: DISPLAY_FONT },
    h6: { fontFamily: DISPLAY_FONT },
  },
});
// import { TooltipProvider } from './components/SmartEditor/components/ui/tooltip';

// const darkTheme = createTheme({
//   palette: {
//     mode: 'dark',
//     background: {
//       default: '#000000', // Pure black background
//       paper: '#000000',   // Black background for paper elements
//     },
//   },
//   components: {
//     MuiCssBaseline: {
//       styleOverrides: {
//         body: {
//           backgroundColor: '#000000',
//         },
//       },
//     },
//   },
// });

// document.documentElement.classList.add('dark');

ReactDOM.createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <PersistGate loading={<Spinner />} persistor={persistor}>
      <FirebaseContext.Provider value={new Firebase()}>
        <ThemeProvider theme={{ [MATERIAL_THEME_ID]: muiTheme }}>
          <JoyCssVarsProvider defaultMode="dark">
            <ErrorBoundary>
              <App />
            </ErrorBoundary>
          </JoyCssVarsProvider>
        </ThemeProvider>
      </FirebaseContext.Provider>
    </PersistGate>
  </Provider>
);
